import { LocalStorageKeys } from '@containers/App';
import TicketPaginationQuery from '@interfaces/ehss/ticket-pagination-query';
import { PillarNames } from '@interfaces/pillar';

import TicketService from './ehss/Ticket';
import TicketServiceLI from './TicketServiceLI';


export default class HistoryRequestsInterceptor {

  private historyServiceEHSS: TicketService = new TicketService;
  private historyServiceLI: TicketServiceLI = new TicketServiceLI;
  private currentPillar: any;

  async paging(query: TicketPaginationQuery, fields?: string[]): Promise<any> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);

    let res;
    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.historyServiceEHSS.paging(query, fields);
        break;
      case PillarNames.LI:
        res = await this.historyServiceLI.paging(query, fields);
        break;
    }
    return res;
  }

}